import React, { useState, useContext, useEffect, useRef } from 'react'
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import { navigate } from 'gatsby'
import { useForm } from 'react-hook-form'
import DatePicker from 'react-datepicker'
import axios from 'axios'
import Select from 'react-select'
import { AppContext } from '../contexts'
import Layout from '../components/layout'
import Loader from '../components/loader'
import ErrorDialog from '../components/errorDialog'
import { date } from '../utils/format'
import 'react-datepicker/dist/react-datepicker.css'
import SliderDesktop from '../components/sliderDesktopBM'
import SliderMobile from '../components/sliderMobileBM'
import { Multiselect } from 'multiselect-react-dropdown'
import Articles from '../components/articlesBM'
import KeyCoverage from '../components/keycoverage'
import SelectArea from '../config/area'
import format from '../utils/format'
import TooltipItem from '../components/tooltipItem'
import lang from '../languages/bm'
import CampaignInfo from '../components/campaignInfo'
import AreaMenu from '../components/annual-menu'
import moment from 'moment'

const GetQuotePage = () => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const state = useContext(AppContext)
  const myRef = useRef()
  const { insured, setInsured } = state
  const [hideAreaMenu, setHideAreaMenu] = useState(true)
  const [dateOfBirth, setDateOfBirth] = useState(insured.dateOfBirth)
  const [pocFrom, setPocFrom] = useState(insured.pocFrom)
  const [pocTo, setPocTo] = useState(insured.pocTo)
  const [selectedCoverage, setSelectedCoverage] = useState(insured.selectedCoverage)
  const [tripType, setTripType] = useState(insured.tripType)
  const [email, setEmail] = useState(insured.email)
  const [email2, setEmail2] = useState(insured.email2)
  const [travelType, setTravelType] = useState(insured.travelType)
  const [headCount, setHeadCount] = useState(insured.headCount)
  const [adultCount, setAdultCount] = useState(insured.adultCount)
  const [childCount, setChildCount] = useState(insured.childCount)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [clickedOutside, setClickedOutside] = useState(false)
  const [selectedCountries, setSelectedCountries] = useState(insured.selectedCountries)
  //for travellers
  const [isOpened, setIsOpened] = useState(false)
  const { inputAreaList } = state
  //const [isActive, setActive] = useState(insured.isActive)
  const [quoteOption, setQuoteOption] = useState(insured.quoteOption)
  const [isMaxHeadCount, setMaxHeadCount] = useState(insured.isMaxHeadCount)
  const [isMinHeadCount, setMinHeadCount] = useState(insured.isMinHeadCount)
  const [isMaxHeadCountChild, setMaxHeadCountChild] = useState(insured.isMaxHeadCountChild)
  const [isMinHeadCountChild, setMinHeadCountChild] = useState(insured.isMinHeadCountChild)
  const [toAutofocus, setToAutofocus] = useState(false)
  const { register, reset, setValue, handleSubmit, setError, errors } = useForm({
    defaultValues: {
      email: insured.email,
      email2: insured.email2,
      email3: insured.email3,
      pdpaAgree: insured.pdpaAgree,
      pocFrom: insured.pocFrom,
      pocTo: insured.pocTo,
      selectedCountries: insured.selectedCountries,
      declareBox: insured.declareBox,
      annualArea: null,
    },
  })
  const handleClickOutside = (e) => {
    if (
      e.target.name === 'traveller' ||
      e.target.name === 'btnplus' ||
      e.target.name === 'btnminus'
    ) {
      setIsOpened(true)
    } else {
      setIsOpened(false)
    }
  }
  const onSelectCountry = (selectedList, selectedItem) => {
    const list = [...inputAreaList]
    list.splice(selectedList.length, 0, {})
    for (const i of selectedList) {
      list[selectedList.length - 1].label = selectedItem.label
      list[selectedList.length - 1].value = selectedItem.value
    }
    state.setInputAreaList(list)
    if (errors.selectedCountries) {
      errors.selectedCountries = null
    }
  }

  const onRemoveCountry = (selectedList, selectedItem) => {
    const list = [...inputAreaList]
    list.splice(selectedList.length, 1)
    var count = 0
    for (const i of selectedList) {
      list[count].label = i.label
      list[count].value = i.value
      count++
    }
    state.setInputAreaList(list)
  }

  useEffect(() => {
    document.cookie = `lang=${lang.id}; path=/`
    state.setLanguage(lang.id)
  }, [])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  let maxDate = new Date()
  let minDate = new Date()
  let midDate = new Date()
  maxDate.setFullYear(maxDate.getFullYear() - 0)
  //set 12 MONTHS max.
  maxDate.setMonth(maxDate.getMonth() + 12)
  minDate.setFullYear(minDate.getFullYear() - 0)
  midDate.setFullYear(midDate.getFullYear() - 0)

  const handlePolicyDate = (value) => {
    setPocFrom(value)
    setValue('pocFrom', value.toString(), true)
    if (travelType === 'annual') {
      const newPocTo = new Date(value)
      newPocTo.setFullYear(newPocTo.getFullYear() + 1)
      newPocTo.setDate(newPocTo.getDate() - 1)
      setPocTo(newPocTo)
    } else {
      setPocTo('')
    }
    setValue('pocTo', '', true)
    if (errors.pocFrom) {
      errors.pocFrom = null
    }
    state.setInsured({
      toAutofocus: true,
    })
  }

  const handlePolicyToDate = (value) => {
    setPocTo(value)
    setValue('pocTo', value.toString(), true)
    if (errors.pocTo) {
      errors.pocTo = null
    }
  }

  const handleHeadCountMinus = (value) => {
    if (state.insured.adultCount <= 2) {
      setMinHeadCount(true)
      setMaxHeadCount(false)
    } else {
      setMinHeadCount(false)
      setMaxHeadCount(false)
    }
    if (state.insured.headCount > 1 && state.insured.adultCount > 1) {
      state.setInsured({
        headCount: state.insured.headCount - 1,
        adultCount: state.insured.adultCount - 1,
        isMinHeadCount: isMinHeadCount,
        isMaxHeadCount: isMaxHeadCount,
      })
    }
  }

  const handleHeadCountPlus = (value) => {
    if (parseInt(state.insured.adultCount) + parseInt(state.insured.childCount) >= 19) {
      setMaxHeadCount(true)
      setMinHeadCount(false)
    } else {
      setMinHeadCount(false)
      setMaxHeadCount(false)
    }

    if (state.insured.headCount < 20) {
      state.setInsured({
        headCount: state.insured.headCount + 1,
        adultCount: state.insured.adultCount + 1,
        isMinHeadCount: isMinHeadCount,
        isMaxHeadCount: isMaxHeadCount,
      })
    }
  }

  const handleHeadCountMinusChild = (value) => {
    if (state.insured.childCount <= 1) {
      setMinHeadCountChild(true)
      setMaxHeadCountChild(false)
    } else {
      setMinHeadCountChild(false)
      setMaxHeadCountChild(false)
    }
    if (state.insured.headCount > 1 && state.insured.childCount > 0) {
      state.setInsured({
        headCount: state.insured.headCount - 1,
        childCount: state.insured.childCount - 1,
        isMinHeadCountChild: isMinHeadCountChild,
        isMaxHeadCountChild: isMaxHeadCountChild,
      })
    }
  }

  const handleHeadCountPlusChild = (value) => {
    if (parseInt(state.insured.adultCount) + parseInt(state.insured.childCount) >= 19) {
      setMaxHeadCountChild(true)
      setMinHeadCountChild(false)
    } else {
      setMinHeadCountChild(false)
      setMaxHeadCountChild(false)
    }

    if (state.insured.headCount < 20) {
      state.setInsured({
        headCount: state.insured.headCount + 1,
        childCount: state.insured.childCount + 1,
        isMinHeadCountChild: isMinHeadCountChild,
        isMaxHeadCountChild: isMaxHeadCountChild,
      })
    }
  }

  const handleDoB = (value) => {
    const selectedDob = new Date(value)
    const day = String(selectedDob.getDate()).padStart(2, '0')
    const month = String(selectedDob.getMonth() + 1).padStart(2, '0')
    const year = selectedDob.getFullYear()
    const formattedDate = `${month}/${day}/${year}`

    setDateOfBirth(formattedDate)

    if (errors.dob) {
      errors.dob = null
    }
  }

  const optionTripType = [
    { value: 'single', label: 'Single' },
    //	{ value: 'annual', label: 'Annual' }
  ]

  const handleTripType = (tripType) => {
    state.setInsured({
      tripType: tripType.value,
    })
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
      color: state.isSelected ? 'white' : '#5F5456',
      backgroundColor: state.isSelected ? '#CC0022' : 'white',
    }),
    control: (provided, state) => {
      // none of react-select's styles are passed to <Control />
      const cstyle = {
        paddingTop: 12,
        border: 'none',
        paddingLeft: 5,
      }
      return { ...provided, ...cstyle }
    },
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
  }
  const onSubmit = (data) => {
    let hasError = 'N'

    // overseas - email
    // domestic - email2
    // annual - email3

    if (travelType === 'overseas') {
      if (state.inputAreaList.length === 0) {
        setError(`selectedCountries`, 'error')
        hasError = 'Y'
      }
      if (data.email === '') {
        setError(`email`, 'required', 'error')
        hasError = 'Y'
      }
    } else if (travelType === 'domestic') {
      if (data.email2 === '') {
        setError(`email2`, 'required', 'error')
        hasError = 'Y'
      }
    } else if (travelType === 'annual') {
      if (data.annualArea === '') {
        setError('annualArea', 'error')
        hasError = 'Y'
      }

      if (dateOfBirth === '') {
        setError('dob', 'error')
        hasError = 'Y'
      }

      if (data.email3 === '') {
        setError(`email3`, 'required', 'error')
        hasError = 'Y'
      }
    }

    if (pocFrom === '') {
      setError(`pocFrom`, 'error')
      hasError = 'Y'
    }

    if (pocTo === '') {
      setError(`pocTo`, 'error')
      hasError = 'Y'
    }

    if (hasError === 'N') {
      let fromDate = new Date(pocFrom)
      let toDate = new Date(pocTo)
      let travelPackage = 'individual'
      if (insured.headCount > 1) {
        travelPackage = 'group'
      }

      let curArea = 1

      if (travelType === 'domestic') {
        curArea = 1
      } else if (travelType === 'overseas') {
        for (const coverArea of state.inputAreaList) {
          if (coverArea.value.charAt(1) > curArea) {
            curArea = coverArea.value.charAt(1)
          }
        }
      } else if (travelType === 'annual') {
        curArea = insured.curArea
      }

      const productType = '37a86a0964d142a744cc32dbda2ed87a51e06b10b6f2790b3755a9246c83b8d2455a'

      const formattedDob = moment(dateOfBirth, "MM/DD/YYYY").format("DD/MM/YYYY");

      state.setInsured({
        selectedCoverage: 'WithCovidCoverage',
        tripType: tripType,
        travelType: travelType,
        selectedCountries: selectedCountries,
        pocFrom: `${fromDate.getMonth() + 1}/${fromDate.getDate()}/${fromDate.getFullYear()}`,
        pocTo: `${toDate.getMonth() + 1}/${toDate.getDate()}/${toDate.getFullYear()}`,
        travelPackage: travelPackage,
        curArea: curArea,
        email: data.email,
        email2: data.email2,
        email3: data.email3,
        dob: travelType === 'annual' ? formattedDob : '',
      })
      setIsLoading(true)
      axios
        .post('/quote/securetravel/', {
          travelType: travelType === 'annual' ? '-' : travelType,
          travelFromDate: format.date(fromDate),
          travelToDate: format.date(toDate),
          travelPackage: travelType === 'annual' ? '-' : travelPackage,
          travelTrip: travelType === 'annual' ? travelType : tripType.toLowerCase(),
          adultPax: insured.headCount,
          childPax: 0,
          destination: curArea,
          destinationList: [],
          productType,
          dob: travelType === 'annual' ? formattedDob : '',
          ...(data.email ? { email: data.email } : {}),
          ...(data.email2 ? { email2: data.email2 } : {}),
          ...(data.email3 ? { email3: data.email3 } : {}),
        })
        .then(function (response) {
          // console.log('Checking response from landing page')
          // console.log(response)

          // return

          if (Array.isArray(response.data)) {
            state.setPlans(response.data)
            if (travelType === 'domestic') {
              navigate('/plan-dom')
            } else {
              navigate('/plans')
            }
          } else {
            setIsError(true)
          }
        })
        .catch(function (error) {
          setIsError(true)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  const CustomPolicyFromDateInput = ({ x_data }) => {
    const ExampleCustomInput = ({ value, onClick }) => (
      <>
        <input
          type="text"
          className="floating__input"
          placeholder={
            travelType === 'domestic'
              ? 'Tarikh Bertolak'
              : travelType === 'annual'
                ? 'Tarikh Mula Dasar'
                : 'Bertolak dari Malaysia'
          }
          onClick={onClick}
          value={value}
        />
        <label
          className="floating__label"
          data-content={
            travelType === 'domestic'
              ? 'Tarikh Bertolak'
              : travelType === 'annual'
                ? 'Tarikh Mula Dasar'
                : 'Bertolak dari Malaysia'
          }
        >
          <span className="hidden--visually">Tarikh Bertolak</span>
        </label>
      </>
    )
    return (
      <DatePicker
        selected={pocFrom ? new Date(pocFrom) : pocFrom}
        onChange={handlePolicyDate}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="dd/MM/yyyy"
        minDate={new Date()}
        maxDate={moment().add(1, 'years').subtract(1, 'days').toDate()}
        // openToDate={midDate}
        customInput={<ExampleCustomInput />}
      />
    )
  }

  const CustomPolicyToDateInput = ({ autoFocus }) => {
    let maxDateReturn = new Date(pocFrom)
    let minDateReturn = new Date(pocFrom)
    let midDateReturn = new Date(pocFrom)
    maxDateReturn.setFullYear(maxDateReturn.getFullYear() - 0)
    maxDateReturn.setDate(maxDateReturn.getDate() + 119)
    minDateReturn.setFullYear(minDateReturn.getFullYear() - 0)
    midDateReturn.setFullYear(midDateReturn.getFullYear() - 0)
    let focusValue = ''
    if (state.insured.toAutofocus && pocTo === '') {
      focusValue = 'autofocus'
    }
    const ExampleCustomInput2 = ({ value, onClick }) => (
      <>
        <input
          type="text"
          className="floating__input"
          placeholder={
            travelType === 'domestic'
              ? 'Tarikh Pulang'
              : travelType === 'annual'
                ? 'Tarikh Tamat Polisi'
                : 'Pulang ke Malaysia'
          }
          onClick={onClick}
          value={value}
          autoFocus={focusValue}
          disabled={travelType === 'annual'}
          ref={focusValue === 'autofocus' && value === '' ? onClick : null}
        />
        <label
          className="floating__label"
          data-content={
            travelType === 'domestic'
              ? 'Tarikh Pulang'
              : travelType === 'annual'
                ? 'Tarikh Tamat Polisi'
                : 'Pulang ke Malaysia'
          }
        >
          <span className="hidden--visually">
            {travelType === 'domestic'
              ? 'Tarikh Pulang'
              : travelType === 'annual'
                ? 'Tarikh Tamat Polisi'
                : 'Pulang ke Malaysia'}
          </span>
        </label>
      </>
    )
    return (
      <DatePicker
        selected={pocTo ? new Date(pocTo) : pocTo}
        onChange={handlePolicyToDate}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="dd/MM/yyyy"
        minDate={minDateReturn}
        maxDate={maxDateReturn}
        openToDate={midDateReturn}
        customInput={<ExampleCustomInput2 />}
        shouldCloseOnSelect={true}
      />
    )
  }

  const CustomDobInput = () => {
    minDate = moment(insured.pocFrom).subtract(80, 'years').add(1, 'days').toDate()
    maxDate = moment(insured.pocFrom).subtract(16, 'years').toDate()
    midDate = moment(insured.pocFrom).subtract(34, 'years').toDate()

    const ExampleCustomInput = ({ value, onClick }) => (
      <>
        <input
          type="text"
          className="floating__input"
          placeholder={lang.dob}
          //disabled={disableDoB}
          disabled={false}
          readOnly={true}
          onClick={onClick}
          value={value}
        />
        <label className="floating__label" data-content={lang.dob}>
          <span className="hidden--visually">{lang.dob}</span>
        </label>
      </>
    )
    return (
      <DatePicker
        selected={dateOfBirth ? new Date(dateOfBirth) : dateOfBirth}
        onChange={(e) => handleDoB(e)}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="dd/MM/yyyy"
        minDate={minDate}
        maxDate={maxDate}
        openToDate={midDate}
        customInput={<ExampleCustomInput />}
      />
    )
  }

  const toggleClassOverseas = () => {
    //setActive(true)
    setQuoteOption('overseas')
    state.setInsured({
      //isActive: true,
      quoteOption: 'overseas',
    })
    setPocFrom(insured.pocFrom)
    setPocTo('')
    setTravelType('overseas')

    reset({ email2: '', email3: '', declareBox: '' })
  }

  const toggleClassDomestic = () => {
    //setActive(false)
    setQuoteOption('domestic')
    state.setInsured({
      //isActive: false,
      quoteOption: 'domestic',
    })
    setPocFrom(insured.pocFrom)
    setPocTo('')
    setTravelType('domestic')

    reset({ email1: '', email3: '', declareBox: '' })
  }

  const toggleClassAnnual = () => {
    const defaultPocTo = new Date(insured.pocFrom)
    defaultPocTo.setFullYear(defaultPocTo.getFullYear() + 1)
    defaultPocTo.setDate(defaultPocTo.getDate() - 1)
    setPocTo(defaultPocTo)
    //setActive(false)
    setQuoteOption('annual')
    state.setInsured({
      //isActive: false,
      quoteOption: 'annual',
    })
    setPocFrom(insured.pocFrom)
    setTravelType('annual')

    reset({ email1: '', email2: '', declareBox: '' })

    state.setInsured({
      ...state.insured,
      adultCount: 1,
      childCount: 0,
      headCount: 1,
    })

    setMinHeadCount(true)
    setMinHeadCountChild(true)
  }

  const openAreaMenu = () => {
    setHideAreaMenu(false)
  }

  const closeAreaMenu = () => {
    setHideAreaMenu(true)
  }

  return (
    <Layout
      pageTitle="Get cover with the best online travel insurance Malaysia and allowing you to enjoy a worry-free travel with our comprehensive protection."
      isLanding={true}
      lang={lang}
    >
      <div className="btn-desktop_res">
        <SliderDesktop />
      </div>
      <div className="btn-mobile_res">
        <SliderMobile />
      </div>
      <div className="form_tab">
        <div className="tab col-lg-8 col-md-8 padd">
          <ul class="nav nav-tabs nav-justified">
            <li class="nav-item tab-one">
              <a
                //class={isActive ? "nav-link active" : "nav-link"}
                class={quoteOption === 'overseas' ? 'nav-link active' : 'nav-link'}
                href="#first10"
                data-toggle="tab"
                onClick={toggleClassOverseas}
              >
                <img
                  className="ico-tab"
                  src={'/securetravel/images/ico-oversea.svg'}
                  alt="oversea"
                />
                {lang.travellingOverseas}
              </a>
            </li>
            <li class="nav-item tab-two">
              <a
                //class={isActive ? "nav-link" : "nav-link active"}
                class={quoteOption === 'domestic' ? 'nav-link active' : 'nav-link'}
                href="#second10"
                data-toggle="tab"
                onClick={toggleClassDomestic}
              >
                <img
                  className="ico-tab"
                  src={'/securetravel/images/ico-domestic.svg'}
                  alt="oversea"
                />
                {lang.domestic}
              </a>
            </li>
            <li class="nav-item tab-three">
              <a
                //class={isActive ? "nav-link" : "nav-link active"}
                class={quoteOption === 'annual' ? 'nav-link active' : 'nav-link'}
                href="#third10"
                data-toggle="tab"
                onClick={toggleClassAnnual}
              >
                <img
                  className="ico-tab"
                  src={'/securetravel/images/ico-oversea.svg'}
                  alt="oversea"
                />
                {lang.annual}
              </a>
            </li>
          </ul>
        </div>
        {/* overseas */}
        <div className="main-form">
          <div class="tab-content">
            <div
              id="first10"
              // class={
              //   isActive
              //     ? "tab-pane fade show active"
              //     : "tab-pane fade show inactive"
              // }
              class={
                quoteOption === 'overseas'
                  ? 'tab-pane fade show active'
                  : 'tab-pane fade show inactive'
              }
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-lg-3 col-md-12 mt-2 field_pad">
                    <div className="">
                      <Multiselect
                        displayValue="label"
                        id="selectedCountries"
                        name="selectedCountries"
                        onRemove={onRemoveCountry}
                        onSearch={function noRefCheck() { }}
                        onSelect={onSelectCountry}
                        selectedValues={inputAreaList}
                        options={SelectArea.area}
                        placeholder={lang.enterDestination}
                        style={{
                          chips: {
                            background: 'red',
                          },
                          multiselectContainer: {
                            color: '#000',
                            float: 'left',
                          },
                          searchBox: {
                            border: '1px solid #ccc',
                            'border-radius': '5px',
                          },
                        }}
                      />
                    </div>
                    <input type="hidden" name="selectedCountries" />
                    {errors.selectedCountries && (
                      <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                    )}
                  </div>
                  <div className="col-lg-9 col-md-12  mt-2 field_pad">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 field_pad">
                        <div className="floating" style={{ maxHeight: '57px' }}>
                          <CustomPolicyFromDateInput x_data={insured.pocFrom} />
                        </div>
                        <input type="hidden" name="pocFrom" placeholder={lang.depart} />
                        {errors.pocFrom && (
                          <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-3 field_pad">
                        <div className="floating" style={{ maxHeight: '57px' }}>
                          <CustomPolicyToDateInput />
                        </div>
                        <input type="hidden" name="pocTo" placeholder={lang.return} />
                        {errors.pocTo && (
                          <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                        )}
                      </div>
                      <div className="col-md-3 hidden">
                        <div className="floating">
                          <div className="select">
                            <Select
                              styles={customStyles}
                              className="floating__input3"
                              name="tripType"
                              id="tripType"
                              value={optionTripType.find((obj) => obj.value === 'single')}
                              onChange={handleTripType}
                              options={optionTripType}
                              placeholder="please select"
                            />
                            <label className="floating-label">Trip Type</label>
                          </div>
                        </div>
                        <input type="hidden" name="tripType" />
                        {errors.tripType && (
                          <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-3 field_pad">
                        <div className="floating">
                          <input
                            type="text"
                            name="email"
                            autoComplete="off"
                            id="email"
                            placeholder={lang.emailAddress}
                            className="floating__input"
                            ref={register({ pattern: mailRegex })}
                          />
                          <label
                            htmlFor="input__username"
                            className="floating__label"
                            data-content={lang.emailAddress}
                          >
                            <span className="hidden--visually">{lang.emailAddress} </span>
                          </label>
                        </div>
                        {errors.email && errors.email.type === 'required' && (
                          <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                        )}
                        {errors.email && errors.email.type === 'pattern' && (
                          <div className="invalid-feedback d-block">{lang.error.validEmail}</div>
                        )}
                        {errors.email && errors.email.type === 'maildom' && (
                          <div className="invalid-feedback d-block">{lang.error.validEmail}</div>
                        )}
                      </div>

                      <div className="col-md-3 field_pad">
                        <div className="floating">
                          <input
                            type="text"
                            name="traveller"
                            placeholder="traveller"
                            className="floating__input"
                            readOnly
                          />
                          <label
                            className="floating__label"
                            data-content={
                              (state.insured.adultCount > 1
                                ? state.insured.adultCount + ' Dewasa '
                                : '1 Dewasa ') +
                              (state.insured.childCount > 1
                                ? state.insured.childCount + ' Kanak-kanak'
                                : state.insured.childCount + ' Kanak ')
                            }
                          >
                            <span className="hidden--visually">Traveller</span>
                          </label>
                        </div>
                        {isOpened && (
                          <div
                            className="traveller-bg"
                            data-keyboard="false"
                            data-backdrop="static"
                          >
                            <div className="traveller_title">
                              <div>
                                <TooltipItem id="traveller" message={lang.travellerTooltip} />
                                <span className="traveller_tooltips-tx">
                                  {' '}
                                  {lang.individualGroup}{' '}
                                </span>
                              </div>
                            </div>

                            <div className="traveller_tx">
                              <div className="bold mt-4"> {lang.adult} </div>
                            </div>
                            <div className="traveller_plus-minus">
                              <button
                                type="button"
                                name="btnplus"
                                onClick={handleHeadCountMinus}
                                className={
                                  isMinHeadCount ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                -
                              </button>
                              {/* <span className="traveller_total">{state.insured.headCount}</span> */}
                              <span className="traveller_total">{state.insured.adultCount}</span>
                              <button
                                type="button"
                                name="btnminus"
                                onClick={handleHeadCountPlus}
                                className={
                                  isMaxHeadCount ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                +
                              </button>
                            </div>
                            <div className="traveller_tx">
                              <div className="bold mt-4"> {lang.child} </div>
                            </div>
                            <div className="traveller_plus-minus">
                              <button
                                type="button"
                                name="btnplus"
                                onClick={handleHeadCountMinusChild}
                                className={
                                  isMinHeadCountChild ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                -
                              </button>
                              <span className="traveller_total">{state.insured.childCount}</span>
                              <button
                                type="button"
                                name="btnminus"
                                onClick={handleHeadCountPlusChild}
                                className={
                                  isMaxHeadCountChild ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 mb-2 mt-2">
                    <label class="font-weight-normal form-check-label">
                      <input
                        type="checkbox"
                        id="declareBox"
                        name="declareBox"
                        class="form-check-input"
                        ref={register({ required: true })}
                      />
                      {lang.declaration}
                    </label>
                    {errors.declareBox && (
                      <div className="invalid-feedback d-block" style={{ paddingLeft: '15px' }}>
                        {lang.error.tickPolicyCondition}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 mb-3 quote_tnc">
                    {lang.tnc}{' '}
                    <a href="https://www.berjayasompo.com.my/privacy-notice" target="_blank">
                      {lang.tncpn}
                    </a>
                    .
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-quick-quote">
                  {lang.getQuote}
                </button>
              </form>
            </div>
            {/* domestic */}
            <div
              id="second10"
              // class={
              //   isActive
              //     ? "tab-pane fade show inactive"
              //     : "tab-pane fade show active"
              // }
              class={
                quoteOption === 'domestic'
                  ? 'tab-pane fade show active'
                  : 'tab-pane fade show inactive'
              }
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-lg-3 col-md-12 mt-2 field_pad">
                    <div className="floating field-disable">
                      <input
                        type="text"
                        disabled
                        id="selectedCountries"
                        name="selectedCountries"
                        placeholder={lang.withinMalaysia}
                        className="floating__input"
                      />
                      <label
                        htmlFor="input__username"
                        className="floating__label"
                        data-content={lang.withinMalaysia}
                      >
                        <span className="hidden--visually">Destinations</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-9 col-md-12  mt-2 field_pad">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 field_pad">
                        <div className="floating" style={{ maxHeight: '57px' }}>
                          <CustomPolicyFromDateInput x_data={insured.pocFrom} />
                        </div>
                        <input type="hidden" name="pocFrom" placeholder={'Departure Date'} />
                        {errors.pocFrom && (
                          <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-3 field_pad">
                        <div className="floating" style={{ maxHeight: '57px' }}>
                          <CustomPolicyToDateInput />
                        </div>
                        <input type="hidden" name="pocTo" placeholder="Return Date" />
                        {errors.pocTo && (
                          <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-3 field_pad">
                        <div className="floating">
                          <input
                            type="text"
                            name="email2"
                            autoComplete="off"
                            id="email2"
                            placeholder={lang.emailAddress}
                            className="floating__input"
                            ref={register({ pattern: mailRegex })}
                          />
                          <label
                            htmlFor="input__username"
                            className="floating__label"
                            data-content={lang.emailAddress}
                          >
                            <span className="hidden--visually">{lang.emailAddress} </span>
                          </label>
                        </div>
                        {errors.email2 && errors.email2.type === 'required' && (
                          <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                        )}
                        {errors.email2 && errors.email2.type === 'pattern' && (
                          <div className="invalid-feedback d-block">{lang.error.validEmail}</div>
                        )}
                        {errors.email2 && errors.email2.type === 'maildom' && (
                          <div className="invalid-feedback d-block">{lang.error.validEmail}</div>
                        )}
                      </div>
                      <div className="col-lg-3 col-md-3 field_pad">
                        <div className="floating">
                          <input
                            type="text"
                            name="traveller"
                            // disabled="disabled"
                            placeholder="traveller"
                            className="floating__input"
                            readOnly
                          />
                          <label
                            className="floating__label"
                            data-content={
                              (state.insured.adultCount > 1
                                ? state.insured.adultCount + ' Dewasa '
                                : '1 Dewasa ') +
                              (state.insured.childCount > 1
                                ? state.insured.childCount + ' Kanak-kanak'
                                : state.insured.childCount + ' Kanak ')
                            }
                          >
                            <span className="hidden--visually">Traveller</span>
                          </label>
                        </div>
                        {isOpened && (
                          <div
                            className="traveller-bg"
                            data-keyboard="false"
                            data-backdrop="static"
                          >
                            <div className="traveller_title">
                              <div>
                                <TooltipItem id="traveller" message={lang.travellerTooltip} />
                                <span className="traveller_tooltips-tx">
                                  {' '}
                                  {lang.individualGroup}{' '}
                                </span>
                              </div>
                            </div>
                            <div className="traveller_tx">
                              <div className="bold mt-4"> {lang.adult} </div>
                            </div>
                            <div className="traveller_plus-minus">
                              <button
                                type="button"
                                name="btnplus"
                                onClick={handleHeadCountMinus}
                                className={
                                  isMinHeadCount ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                -
                              </button>
                              <span className="traveller_total">{state.insured.adultCount}</span>
                              <button
                                type="button"
                                name="btnminus"
                                onClick={handleHeadCountPlus}
                                className={
                                  isMaxHeadCount ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                +
                              </button>
                            </div>

                            <div>
                              <div className="traveller_tx">
                                <div className="bold mt-4"> {lang.child} </div>
                              </div>
                            </div>
                            <div className="traveller_plus-minus">
                              <button
                                type="button"
                                name="btnplus"
                                onClick={handleHeadCountMinusChild}
                                className={
                                  isMinHeadCountChild ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                -
                              </button>
                              <span className="traveller_total">{state.insured.childCount}</span>
                              <button
                                type="button"
                                name="btnminus"
                                onClick={handleHeadCountPlusChild}
                                className={
                                  isMaxHeadCountChild ? 'traveller_btn inactive' : 'traveller_btn'
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 mb-2 mt-2">
                    <label class="font-weight-normal form-check-label">
                      <input
                        type="checkbox"
                        id="declareBox"
                        name="declareBox"
                        class="form-check-input"
                        ref={register({ required: true })}
                      />
                      {lang.declaration}
                    </label>
                    {errors.declareBox && (
                      <div className="invalid-feedback d-block" style={{ paddingLeft: '15px' }}>
                        {lang.error.tickPolicyCondition}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-12 mb-3 mt-1 quote_tnc">
                    <div>{lang.domesticNotification}</div>
                    <div className="mt-2">
                      {lang.tnc}{' '}
                      <a href="https://www.berjayasompo.com.my/privacy-notice" target="_blank">
                        {lang.tncpn}
                      </a>
                      .
                    </div>
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-quick-quote">
                  {lang.getQuote}
                </button>
              </form>
            </div>
            {/* Annual */}
            <div
              id="third10"
              // class={
              //   isActive
              //     ? "tab-pane fade show active"
              //     : "tab-pane fade show inactive"
              // }
              class={
                quoteOption === 'annual'
                  ? 'tab-pane fade show active'
                  : 'tab-pane fade show inactive'
              }
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-lg-9 col-md-12 mt-2 field_pad">
                    <div className="floating" onClick={openAreaMenu} onBlur={closeAreaMenu}>
                      {/* <Multiselect
                        displayValue="label"
                        id="selectedCountries"
                        name="selectedCountries"
                        onRemove={onRemoveCountry}
                        onSearch={function noRefCheck() {}}
                        onSelect={onSelectCountry}
                        selectedValues={inputAreaList}
                        options={SelectArea.area}
                        placeholder={lang.enterDestination}
                        style={{
                          chips: {
                            background: 'red',
                          },
                          multiselectContainer: {
                            color: '#000',
                            float: 'left',
                          },
                          searchBox: {
                            border: '1px solid red',
                            'border-radius': '5px',
                          },
                        }}
                      /> */}
                      <input
                        type="text"
                        name="annualArea"
                        className="floating__input"
                        id="annualArea"
                        autoComplete="off"
                        placeholder="Select Your Destinations Area / Region"
                        ref={register({ required: false })}
                      />
                      <label
                        className="floating__label"
                        data-content={'Select Your Destinations Area / Region'}
                      >
                        <span className="hidden--visually">
                          Select Your Destinations Area / Region
                        </span>
                      </label>
                    </div>
                    <input type="hidden" name="annualArea" />
                    {errors.annualArea && (
                      <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                    )}
                  </div>

                  <div className="col-lg-3 col-md-3 mt-2 field_pad">
                    <div className="floating">
                      <input
                        type="text"
                        name="email3"
                        autoComplete="off"
                        id="email3"
                        placeholder={lang.emailAddress}
                        className="floating__input"
                        ref={register({ pattern: mailRegex })}
                      />
                      <label
                        htmlFor="input__username"
                        className="floating__label"
                        data-content={lang.emailAddress}
                      >
                        <span className="hidden--visually">{lang.emailAddress} </span>
                      </label>
                    </div>
                    {errors.email3 && errors.email3.type === 'required' && (
                      <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                    )}
                    {errors.email3 && errors.email3.type === 'pattern' && (
                      <div className="invalid-feedback d-block">{lang.error.validEmail}</div>
                    )}
                    {errors.email3 && errors.email3.type === 'maildom' && (
                      <div className="invalid-feedback d-block">{lang.error.validEmail}</div>
                    )}
                  </div>

                  {/* <div className="col-lg-12 col-md-12  mt-2 field_pad"></div>
                  <div className="row"></div> */}
                  <div className="col-lg-3 col-md-3 field_pad">
                    <div className="floating" style={{ maxHeight: '57px' }}>
                      <CustomPolicyFromDateInput x_data={insured.pocFrom} />
                    </div>
                    <input type="hidden" name="pocFrom" placeholder={lang.depart} />
                    {errors.pocFrom && (
                      <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                    )}
                  </div>
                  <div className="col-lg-3 col-md-3 field_pad field-disable">
                    <div className="floating" style={{ maxHeight: '57px' }}>
                      <CustomPolicyToDateInput />
                    </div>
                    <input type="hidden" name="pocTo" placeholder={lang.return} />
                    {errors.pocTo && (
                      <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                    )}
                  </div>
                  <div className="col-lg-3 col-md-3 field_pad">
                    <div className="floating" style={{ maxHeight: '57px' }}>
                      <CustomDobInput />
                    </div>
                    <input type="hidden" name="dob" placeholder={lang.return} />
                    {errors.dob && (
                      <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                    )}
                  </div>
                  <div className="col-md-3 hidden">
                    <div className="floating">
                      <div className="select">
                        <Select
                          styles={customStyles}
                          className="floating__input3"
                          name="tripType"
                          id="tripType"
                          value={optionTripType.find((obj) => obj.value === 'single')}
                          onChange={handleTripType}
                          options={optionTripType}
                          placeholder="please select"
                        />
                        <label className="floating-label">Trip Type</label>
                      </div>
                    </div>
                    <input type="hidden" name="tripType" />
                    {errors.tripType && (
                      <div className="invalid-feedback d-block">{lang.error.fieldRequired}</div>
                    )}
                  </div>

                  <div className="col-md-3 field_pad">
                    <div className="floating field-disable">
                      <input
                        type="text"
                        name="traveller"
                        placeholder="traveller"
                        className="floating__input"
                        disabled
                        readOnly
                      />
                      <label
                        className="floating__label"
                        data-content={
                          state.insured.adultCount > 1
                            ? state.insured.adultCount + ' Adults '
                            : '1 Adult '
                        }
                      >
                        {/* + (state.insured.childCount > 1 ? state.insured.childCount + ' Children' :
                        state.insured.childCount + ' Child ') */}
                        <span className="hidden--visually">Traveller</span>
                      </label>
                    </div>
                    {isOpened && (
                      <div className="traveller-bg" data-keyboard="false" data-backdrop="static">
                        <div className="traveller_title">
                          <div>
                            <TooltipItem id="traveller" message={lang.travellerTooltip} />
                            <span className="traveller_tooltips-tx"> {lang.individualGroup} </span>
                          </div>
                        </div>

                        <div className="traveller_tx">
                          <div className="bold mt-4"> {lang.adult} </div>
                        </div>
                        <div className="traveller_plus-minus">
                          <button
                            type="button"
                            name="btnplus"
                            onClick={handleHeadCountMinus}
                            className={isMinHeadCount ? 'traveller_btn inactive' : 'traveller_btn'}
                          >
                            -
                          </button>
                          {/* <span className="traveller_total">{state.insured.headCount}</span> */}
                          <span className="traveller_total">{state.insured.adultCount}</span>
                          <button
                            type="button"
                            name="btnminus"
                            onClick={handleHeadCountPlus}
                            className={isMaxHeadCount ? 'traveller_btn inactive' : 'traveller_btn'}
                          >
                            +
                          </button>
                        </div>
                        <div className="traveller_tx">
                          <div className="bold mt-4"> {lang.child} </div>
                        </div>
                        <div className="traveller_plus-minus">
                          <button
                            type="button"
                            name="btnplus"
                            onClick={handleHeadCountMinusChild}
                            className={
                              isMinHeadCountChild ? 'traveller_btn inactive' : 'traveller_btn'
                            }
                          >
                            -
                          </button>
                          <span className="traveller_total">{state.insured.childCount}</span>
                          <button
                            type="button"
                            name="btnminus"
                            onClick={handleHeadCountPlusChild}
                            className={
                              isMaxHeadCountChild ? 'traveller_btn inactive' : 'traveller_btn'
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="col-lg-12 mb-2 mt-2">
                    <label class="font-weight-normal form-check-label">
                      <input
                        type="checkbox"
                        id="declareBox"
                        name="declareBox"
                        class="form-check-input"
                        ref={register({ required: true })}
                      />
                      {lang.declaration}
                    </label>
                    {errors.declareBox && (
                      <div className="invalid-feedback d-block" style={{ paddingLeft: '15px' }}>
                        {lang.error.tickPolicyCondition}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 mb-3 quote_tnc">
                    {lang.tnc}{' '}
                    <a href="https://www.berjayasompo.com.my/privacy-notice" target="_blank">
                      {lang.tncpn}
                    </a>
                    .
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-quick-quote">
                  {lang.getQuote}
                </button>
              </form>
            </div>
          </div>
        </div>

        <AreaMenu
          isHidden={hideAreaMenu}
          closeAreaMenu={closeAreaMenu}
          insured={insured}
          setInsured={setInsured}
          setValue={setValue}
          lang={lang}
        />
      </div>

      {/* <div className="intro-bg container mt-3">
        <div className="row">
          <div className="col-md-10 mb-5 offset-md-1">
            <div className="page-title">
              <h2 className="main-title">{lang.travelInsurance.title2} </h2>
              <p className="mt-2 sub-title">{lang.travelInsurance.desc4}</p>
            </div>
            <div className="col-md-12 mt-4 text-center tx-note">{lang.travelInsurance.desc5}</div>
          </div>
        </div>
      </div> */}

      <div className="benefits-bg container mt-5">
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <div className="benefits-img_bg"></div>
          </div>

          <div className="col-md-12 col-lg-6 mb-5">
            <div className="row">
              <div className=" col-md-12">
                <div className="page-title">
                  <h2 className="main-title">{lang.travelBenefits.title} </h2>
                  <p className="mt-2 sub-title">{lang.travelBenefits.desc}</p>
                </div>
              </div>
              <div className="col-md-6 col-6 mt-4">
                <div className=" benefits_box">
                  <div className="img">
                    <img
                      src={'/securetravel/images/ico-benefit_1.svg'}
                      alt="Emergency medical evacuation benefits"
                    />
                  </div>
                  <div className="tx">{lang.travelBenefits.benefit1}</div>
                </div>
              </div>
              <div className="col-md-6 col-6 mt-4">
                <div className=" benefits_box">
                  <div className="img">
                    <img
                      src={'/securetravel/images/ico-benefit_2.svg'}
                      alt="Get medical treatment at your home country"
                    />
                  </div>
                  <div className="tx">{lang.travelBenefits.benefit2}</div>
                </div>
              </div>
              <div className="col-md-6 col-6  mt-3">
                <div className=" benefits_box">
                  <div className="img">
                    <img
                      src={'/securetravel/images/ico-benefit_3.svg'}
                      alt="Enjoy travel insurance that covers your medical expenses"
                    />
                  </div>
                  <div className="tx">{lang.travelBenefits.benefit3}</div>
                </div>
              </div>
              <div className="col-md-6 col-6 mt-3 ">
                <div className=" benefits_box">
                  <div className="img">
                    <img
                      src={'/securetravel/images/ico-benefit_4.svg'}
                      alt="Travel insurance Malaysia with trip cancellation"
                    />
                  </div>
                  <div className="tx">{lang.travelBenefits.benefit4}</div>
                </div>
              </div>
              <div className="col-md-6 col-6 mt-3">
                <div className=" benefits_box">
                  <div className="img">
                    <img
                      src={'/securetravel/images/ico-benefit_5.svg'}
                      alt="Travel insurance plan with Covid-19 coverage"
                    />
                  </div>
                  <div className="tx">{lang.travelBenefits.benefit5}</div>
                  <div className="clear"></div>
                </div>
              </div>
              <div className="col-md-6 col-6 mt-3">
                <div className=" benefits_box">
                  <div className="img">
                    <img
                      src={'/securetravel/images/ico-benefit_6.svg'}
                      alt="Trip interruptions coverage"
                    />
                  </div>
                  <div className="tx">{lang.travelBenefits.benefit6} </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <KeyCoverage lang={lang} />
      {/* <Articles lang={lang} /> */}

      {/* mt-5 removed from div below */}
      <div className="benefits-bg container">
        <div>
          {/* [START] Disclaimer */}
          <br />
          <div>
            {lang.disclaimer.line_01}
            <br />
            <br />
            <u>{lang.disclaimer.line_02}</u>
            <br />
            <br />
            {lang.disclaimer.line_03}
            <br />
            <br />
            {lang.disclaimer.line_04}
            <br />
            <br />
            {lang.disclaimer.line_05}
            <br />
            <br />
            {lang.disclaimer.line_06}
          </div>
          {/* [END] Disclaimer */}
        </div>
      </div>

      <div className="product-bg mt-5">
        <div className="container">
          <div className="row">
            <div className="text-center col-md-8 mb-5 offset-md-2">
              <div className="title ">{lang.cross_sell.title}</div>
              <h2 className="mt-2 mb-5 sub-title">{lang.cross_sell.desc}</h2>
            </div>

            <div className="col-md-4 mt-5">
              <div className="box mobile">
                <div className="text-center ico-product">
                  <img
                    src={'../securetravel/images/img-product-secmotor.png'}
                    height="100"
                    width="150"
                  />
                </div>
                <h3 className="tx-product_title">{lang.cross_sell.securemotor_title}</h3>
                <div className="mt-3">
                  <ul>
                    <li>{lang.cross_sell.securemotor_01}</li>
                    <li>{lang.cross_sell.securemotor_02}</li>
                    <li>{lang.cross_sell.securemotor_03}</li>
                    <li>{lang.cross_sell.securemotor_04}</li>
                    <li>{lang.cross_sell.securemotor_05}</li>
                  </ul>
                </div>
                <div className="button-box">
                  <a href="https://online.berjayasompo.com.my/securemotor" target="_blank">
                    <button type="button" className="btn btn-sompo_primary red">
                      {lang.cross_sell.button_02}
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-4 mt-5">
              <div className="box mobile">
                <div className="text-center ico-product">
                  <img
                    src={'../securetravel/images/img-product-snatch.png'}
                    height="100"
                    width="150"
                  />
                </div>
                <h3 className="tx-product_title">{lang.cross_sell.snatch_title}</h3>
                <div className="mt-3">
                  <ul>
                    <li>{lang.cross_sell.snatch_01}</li>
                    <li>{lang.cross_sell.snatch_02}</li>
                    <li>{lang.cross_sell.snatch_03}</li>
                    <li>{lang.cross_sell.snatch_04}</li>
                  </ul>
                </div>
                <div className="button-box">
                  <a
                    href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Medz"
                    target="_blank"
                  >
                    <button type="button" className="btn btn-sompo_primary red">
                      {lang.cross_sell.button_01}
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-4 mt-5">
              <div className="box mobile">
                <div className="text-center ico-product">
                  <img
                    src={'../securetravel/images/img-product-home.png'}
                    height="100"
                    width="150"
                  />
                </div>
                <h3 className="tx-product_title">{lang.cross_sell.home_title}</h3>
                <div className="mt-3">
                  <ul>
                    <li>{lang.cross_sell.home_01}</li>
                    <li>{lang.cross_sell.home_02}</li>
                    <li>{lang.cross_sell.home_03}</li>
                    <li>{lang.cross_sell.home_04}</li>
                  </ul>
                </div>
                <div className="button-box">
                  <a
                    href="https://customer.berjayasompo.com.my/directsales/sh?account_code=10006833#/"
                    target="_blank"
                  >
                    <button type="button" className="btn btn-sompo_primary red">
                      {lang.cross_sell.button_03}
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="seo mt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title bold">{lang.travelInsurance.title}</div>
              <p className="mt-3">{lang.travelInsurance.desc1} </p>

              <p className="mt-3">{lang.travelInsurance.desc2} </p>

              <p className="mt-3 mb-3">{lang.travelInsurance.desc3} </p>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      <ErrorDialog isOpen={isError} toggle={() => setIsError((v) => !v)} lang={lang} />
    </Layout>
  )
}
export default GetQuotePage
